import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { FAQItemList } from "./components/faq-item-list";
import { Text } from "../../components/text";

export const FAQHowToOrder = () => {
  return (
    <>
      <FAQSectionTitle>
        Cara Pemesanan di Jooalan (Reseller & Dropship)
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Bagaimana cara pemesanan di aplikasi Jooalan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Pilih produk varian dan kuantitas yang ingin dibeli.',
              <p key="2">
                Pada produk yang dipilih, jika ingin membeli langsung sebagai reseller, silakan pilih tipe pembelian <b>Beli Putus</b>, namun jika ingin membeli sebagai dropshipper pilih tipe pembelian <b>Dropship</b>
              </p>,
              'Buka keranjang sesuai dengan tipe pembelian yang Anda pilih',
              'Terdapat minimum pembelian pada masing-masing tipe pembelian sehingga Anda harus memenuhi minimum pembelian tersebut sebelum melanjutkan pesanan',
              'Klik Lanjutkan',
              'Pilih alamat tujuan pengiriman',
              'Pilih pengiriman',
              'Klik bayar sekarang, maka akan muncul layar OY! untuk pembayaran dengan berbagai metode pembayaran',
              'Pilih metode pembayaran',
              'Klik lanjutkan',
              'Lakukan pembayaran sesuai pilihan Anda',
              'Pesanan berhasil terbuat dan Anda tinggal menunggu pesanan untuk diproses tim Jooalan',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara mengirim barang sebagai Dropshipper?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Pilih produk varian dan kuantitas yang ingin dibeli. ',
              <p key="2">Pada produk yang dipilih, pilih tipe pembelian Dropship untuk memesan barang-barang yang akan dilakukan dropship, kemudian pilih variannya</p>,
              <p key="3">Buka keranjang sesuai dengan tipe pembelian yang Anda pilih <b>(Reguler - Dropship)</b></p>,
              'Klik Lanjutkan',
              'Centang kirim sebagai dropshipper akan otomatis tercentang',
              'Terdapat informasi Lokasi Gudang Pengiriman untuk memudahkan Anda memberi tahu konsumen tentang lokasi pengiriman atau untuk alamat marketplace Anda',
              'Lengkapi nama, no telepon, dan alamat pengirim, untuk memudahkan identifikasi customer Anda terhadap toko Anda',
              'Klik simpan',
              'Saat bagian dropship sudah terisi lengkap di halaman buat pesanan, pesanan akan dikirim sebagai dropship',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Sebagai dropshipper, bagaimana cara saya melihat daftar pelanggan dan alamat customer saya?
        </FAQButton>
        <FAQItem>
          <Text>
            Anda dapat melihat nama & daftar alamat customer Anda pada halaman Daftar Alamat di halaman Akun
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara mengetahui promo yang ada di Jooalan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik Voucher di halaman buat pesanan atau klik Voucher di halaman akun',
              'Klik pada voucher Anda atau,',
              'Cari voucher jika anda memiliki kode voucher',
              'Klik gunakan',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bisakah saya belanja untuk dikirimkan ke alamat lain?
        </FAQButton>
        <FAQItem>
          <Text>
            Ya, Anda bisa mengirimkan alamat yang sudah ditambahkan di daftar alamat
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara saya mengetahui pengiriman yang tersedia?
        </FAQButton>
        <FAQItem>
          <Text>
            Anda bisa lihat di pilihan pengiriman saat ingin membuat pesanan
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara pembayaran ongkos kirim untuk ekpedisi pilihan lainnya (ACC, Rado, Baraka)?
        </FAQButton>
        <FAQItem>
          <Text>
            Anda melakukan pembayaran ongkos kirim kepada kurir saat barang diterima
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara membatalkan pesanan yang belum dibayar?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Masuk ke menu pesanan',
              'Pilih pesanan dengan status Menunggu Pembayaran',
              'Klik tombol titik tiga di kanan atas',
              'Pilih Batalkan pesanan',
              'Pilih alasan pembatalan',
              'Klik Konfirmasi',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara membatalkan pesanan yang sudah saya bayar?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Masuk ke menu pesanan',
              'Pilih pesanan dengan status Menunggu Konfirmasi',
              'Klik tombol titik tiga di kanan atas',
              'Pilih Batalkan Pesanan',
              'Pilih alasan pembatalan',
              'Klik Konfirmasi',
              'Pesanan akan ditinjau terlebih dahulu untuk bisa dibatalkan atau tidak',
              'Jika disetujui untuk dibatalkan oleh admin, maka status pesanan akan dibatalkan',
              'Jika tidak disetujui untuk dibatalkan oleh admin, maka status pesanan akan tetap dilanjutkan seperti biasa',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara mengajukan komplain barang yang diterima?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik pesanan diterima pada halaman rincian pesanan',
              'Klik produk bermasalah',
              'Masuk ke whatsapp untuk hubungi Customer Service Jooalan',
            ]}
          />
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara melakukan pengembalian dana?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Setelah pengembalian dana disetujui, Anda akan melihat tombol untuk tambahkan nomor rekening di halaman rincian pesanan',
              'Anda akan dialihkan ke Whatsapp untuk mengisikan nomor rekening',
              'Setelah diproses oleh admin, maka status pengembalian dana akan diupdate menjadi “Pengembalian Dana diproses”',
              'Ketika dana sudah ditransfer, status pengembalian dana ialah Selesai',
            ]}
          />
        </FAQItem>
      </Disclosure>
    </>
  )
}